'use client';

import type { ReactNode } from 'react';

import { QueryProvider } from './_providers/query-provider';
import { StoreProvider } from './_providers/store-provider';

export function Providers({ children }: { children: ReactNode }) {
  return (
    <StoreProvider>
      <QueryProvider>{children}</QueryProvider>
    </StoreProvider>
  );
}
